module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 d-flex flex-wrap py-3 pt-4"
  }, [(_vm.getIsGettingReservationById) ? _c('div', {
    staticClass: "text-center"
  }, [_c('loader')], 1) : _c('route-form', {
    attrs: {
      "transfer": _vm.reservation.transport.transfers[0],
      "routes": _vm.routes,
      "reservation": _vm.reservation,
      "title": "Pick up location",
      "type": 1,
      "readOnly": _vm.isReservationReadOnly
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0fa4bf93", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa4bf93"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabTransport.vue
// module id = 1186
// module chunks = 0